import React from 'react';
import moment from 'moment';
import classNames from 'classnames';
import './MessageCard.less';
import { isPendingMessage } from '../../../contexts/messageReplyQueueContext';
import { containsLikelyNorwegianAccountNumber } from '../../../utils/accountNumberUtil';
var toHumanReadableDateTime = function (dt) {
    var createdOn = moment(dt);
    // 1 hour was chosen semi-arbitrarily
    // but we believe that anything more than this, then it becomes more difficult to read
    var absoluteTimeThreshold = moment().subtract(1, 'hours');
    if (createdOn.isAfter(absoluteTimeThreshold)) {
        return createdOn.fromNow(true) + " siden";
    }
    return createdOn.format('HH:mm DD. MMM YYYY');
};
var PendingMessageCard = function (_a) {
    var message = _a.message, onSendRetry = _a.onSendRetry;
    var footerMessage = 'Sender...';
    if ('error' in message) {
        console.error("Failed to send message. Caused by error: " + message.error);
        footerMessage = 'Klarte ikke å sende';
    }
    var handleClick = function (evt) {
        evt.preventDefault();
        if (!isPendingMessage(message)) {
            return;
        }
        onSendRetry(message);
    };
    return (React.createElement("div", { className: classNames('messagecard', 'messagecard--user', 'messagecard--pending') },
        React.createElement("div", { className: 'messagecard__body' },
            React.createElement("p", { className: classNames('messagecard__body__message', { 'messagecard__body__message--error': 'error' in message }) }, message.body),
            React.createElement("p", { className: "messagecard__body__time" },
                React.createElement("span", null, footerMessage),
                React.createElement("button", { className: "messagecard__body__retrybutton", onClick: handleClick, type: "button" }, "Send p\u00E5 nytt")))));
};
var MessageCard = function (props) {
    var message = props.message, currentUser = props.currentUser, onSendRetry = props.onSendRetry, onAskAboutVipps = props.onAskAboutVipps;
    var dateTime = toHumanReadableDateTime(message.createdOn);
    if (isPendingMessage(message)) {
        return React.createElement(PendingMessageCard, { message: message, onSendRetry: onSendRetry });
    }
    var isCurrentUser = 'senderId' in message && message.senderId === (currentUser === null || currentUser === void 0 ? void 0 : currentUser.id);
    var showAccountNumberWarning = !isCurrentUser
        && containsLikelyNorwegianAccountNumber(message.body);
    return (React.createElement("div", { className: classNames('messagecard', {
            'messagecard--user': isCurrentUser,
        }) },
        React.createElement("div", { className: 'messagecard__body' },
            React.createElement("p", { className: classNames('messagecard__body__message', {
                    'messagecard__body__message--user': isCurrentUser,
                }) }, message.body),
            React.createElement("span", { className: "messagecard__body__time" }, dateTime),
            showAccountNumberWarning && React.createElement("aside", { className: "accountnumber-warning", "aria-live": "polite" },
                React.createElement("strong", null, "Dette ser ut som et kontonummer"),
                React.createElement("p", null, "Vi ser for tiden svindelfors\u00F8k der selgere ber om betaling til bankkonto og unng\u00E5r Vipps. F\u00F8r du betaler, sp\u00F8r om selger kan ta Vipps og kontroller at navnet som vises stemmer med personen du handler med. Hvis selger nekter Vipps, oppgir et annet navn eller presser deg til \u00E5 betale raskt, anbefaler vi at du ikke betaler."),
                React.createElement("p", null, "Vipps er heller ikke en garanti for at boka blir sendt."),
                React.createElement("button", { type: "button", onClick: onAskAboutVipps }, "Sp\u00F8r om Vipps")))));
};
export default MessageCard;
